/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
var message_bundle_1 = require('./message_bundle');
exports.MessageBundle = message_bundle_1.MessageBundle;
var xmb_1 = require('./serializers/xmb');
exports.Xmb = xmb_1.Xmb;
var xtb_1 = require('./serializers/xtb');
exports.Xtb = xtb_1.Xtb;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/compiler/src/i18n/index.js
 ** module id = 3
 ** module chunks = 2
 **/